<script>
export default {

    computed: {
        submit() {
            let formFields = {}
            for (const field of this.form.fields) {
                Object.assign(formFields, {[field.handle]: ''})
            }
            return formFields
        },
        fields() {
            let fields = {}
            this.form.fields.forEach(field =>
                fields[field.handle] = field
            )
            return fields
        }
    },

    data() {
        return {            
            errors: '',
            fatalError: false,
            disableSubmit: false,
            successMsg: false
        }
    },

    methods: {
        submitForm() {
            this.clearErrors()
            this.toggleSubmit()
            axios.post(this.form.url, this.submit)
                .then(response => {
                    this.handleSuccess(response.data)
                })
                .catch(error => {
                    this.handleErrors(error.response)
                }).finally(() => {
                     
                });
        },
        clearErrors() {
            this.errors = ''
            this.fatalError = ''
        },
        toggleSubmit() {
            this.disableSubmit = !this.disableSubmit
        },
        handleSuccess(data) {
            if (data.success == true) {
                this.successMsg = this.t.successForm
            }
            this.toggleSubmit()
        },
        handleErrors(errors) {
            if (errors.status == 500) {
                this.fatalError = true
            } else {
                this.errors = errors.data.error
            }           
            this.toggleSubmit()
        },
        createOptions(field) {
            if (field.handle == 'country') {
                return this.countries
            }
            let options = [];
            Object.keys(field.options).forEach(key => options.push({label: field.options[key], value:key }))
            return options
        },
        fieldLabel(field) {
            if (field.type == 'checkboxes' && _.size(field.options) == 1) {
                return false
            }
            if (field.handle in this.t) {
                return this.t[field.handle]
            }
            return field.display
        },
        isHoneypot(field) {
            if (field.handle == this.form.honeypot) {
                return ' field-special'
            }
            return ''
        },
        checkPlacehoderForRange(field) {
            if ("placeholder" in field) {
                if (field.placeholder == 'range') {
                    return 'range'
                }
            }
            return false
        }
    }

};
</script>